import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility for composing Tailwind class strings without conflicts.
 *  - `clsx` handles conditional inputs (`undefined`, `false`, arrays, objects).
 *  - `twMerge` resolves conflicts so `cn("p-2", "p-4")` → `"p-4"`.
 *
 * Primitives should accept a `className` prop and pass it through `cn()` so
 * callers can override or extend base styles. This keeps all primitives
 * composable without exposing internal class structure.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
